
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import PageLayout from "@/components/layout/PageLayout";
import { useToast } from "@/components/ui/use-toast";
import { ContactDetails } from "@/components/admin/ContactDetails";
import { AdminBreadcrumb } from "@/components/admin/AdminBreadcrumb";

const ContactDetailsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [hasAccess, setHasAccess] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkUserAccess = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        
        if (!session) {
          navigate("/auth");
          return;
        }

        // Update to check if user is admin OR producer
        const { data: userRole } = await supabase
          .from("user_roles")
          .select("role")
          .eq("user_id", session.user.id)
          .in("role", ["admin", "producer"])
          .single();

        if (!userRole) {
          toast({
            variant: "destructive",
            title: "Access Denied",
            description: "You don't have permission to access this page.",
          });
          navigate("/dashboard");
          return;
        }

        setHasAccess(true);
      } catch (error) {
        console.error("Error checking access:", error);
        toast({
          variant: "destructive",
          title: "Error",
          description: "An unexpected error occurred. Please try again.",
        });
        navigate("/dashboard");
      } finally {
        setIsLoading(false);
      }
    };

    checkUserAccess();
  }, [navigate, toast]);

  if (isLoading) {
    return (
      <PageLayout>
        <div className="container mx-auto px-4 py-6 flex justify-center items-center min-h-screen">
          <div className="p-8 rounded-md bg-white shadow">
            <p className="text-lg text-center">Loading client details...</p>
          </div>
        </div>
      </PageLayout>
    );
  }

  if (!hasAccess) {
    return null;
  }

  return (
    <PageLayout>
      <div className="container mx-auto px-4 py-6">
        <AdminBreadcrumb 
          currentPage="Client Details" 
          parentPath="/admin/clients"
          parentLabel="Clients"
        />
        <div className="mt-6">
          <ContactDetails />
        </div>
      </div>
    </PageLayout>
  );
};

export default ContactDetailsPage;
